var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-cell"},[_c('span',{staticClass:"grid-cell--title"},[_vm._v(_vm._s(_vm._f("dateFormat")(_vm.templateDate))+" ("+_vm._s(_vm.timezoneEnv)+")")]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }